import { get } from 'utils/lodash'

export const isSameAction = (event, className) => {
  const eventClasses = get(event, 'relatedTarget.classList')
  return eventClasses && eventClasses.contains(className)
}
